<template>
    <section>
        <div
            class="modal-mask"
            v-show="displayModalMessage"
        >
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header"><p class="passe-text-header"></p></slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                            <p></p>
                        </slot>
                    </div>
                    <div class="spin-loader">
                        <span class="loader"></span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: ['displayModalMessage'],
    };
</script>

<style scoped>
    section {
        color: black;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: min(280px, calc(100vw - 3rem));
        max-width: 280px;
        margin: 0 auto;
        padding: 1.25rem 1.5rem;
        background-color: #264271;
        border-radius: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        box-sizing: border-box;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-header{
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 1rem;

    }
    .modal-header p{
        font-size: 1.25rem;
        color:bisque;
        text-align: center;
        margin: 0;
        max-width: 100%;
        overflow-wrap: break-word;
    }

    .modal-default-button {
        float: right;
    }
    .modal-header,
    .modal-body {
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .spin-loader{
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }



    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter-from,
    .modal-leave-to {
        opacity: 0;
    }

    .modal-enter-active .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* Loader */
    .loader {
        width: 48px;
        height: 48px;
        border: 4px solid #fff;
        border-radius: 50%;
        display: inline-block;
        position: relative;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
    }
    .loader::after {
        content: '';
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 56px;
        height: 56px;
        border-radius: 50%;
        border: 3px solid;
        border-color: #ff3d00 transparent;
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
